import { Form } from 'react-bootstrap';

import { useAppDispatch } from '../../../../app/hooks';
import { User } from '../../../../services/UsersService';
import UserUpdateButton from '../../UserUpdateButton';
import { setAdminEmail, setCompanyName, setCSM, setTrackingCodeInstalled } from '../UserSlice';
import { useGetCsmsQuery } from '../../../customerSuccessManager/csmApiSlice';
import { RequireTier } from '../../../auth/RequireTier';

interface UserGeneralTabProps {
  readonly user: User;
}

const UserGeneralTab = (props: UserGeneralTabProps) => {
  const { user } = props;
  const cmsListResult = useGetCsmsQuery();

  const dispatch = useAppDispatch();

  const updateAdminEmail = (email: string) => {
    dispatch(setAdminEmail(email));
  };

  const updateCompanyName = (email: string) => {
    dispatch(setCompanyName(email));
  };

  const updateCSM = (csmId: string) => {
    dispatch(setCSM(csmId));
  };

  const updateTrackingCodeInstalled = (value: boolean) => {
    dispatch(setTrackingCodeInstalled(value));
  };

  return (
    <>
      <div className="form-group">
        <label htmlFor="admin email" className="form-label">
          Admin email address
        </label>
        <RequireTier requiredTier="superadmin" policy="disable" fullWidth>
          <input
            type="email"
            className="form-control"
            id="email"
            defaultValue={user.adminEmail}
            onChange={(event) => {
              updateAdminEmail(event.target.value);
            }}
          />
        </RequireTier>
      </div>

      <RequireTier requiredTier="admin" policy="disable">
        <fieldset className="border-0 p-0 m-0">
          <div className="form-group">
            <label htmlFor="company name" className="form-label">
              Company name
            </label>
            <input
              type="email"
              className="form-control"
              id="companyName"
              defaultValue={user.companyName}
              onChange={(event) => {
                updateCompanyName(event.target.value);
              }}
            />
          </div>

          <Form.Group className="mb-3" controlId="formBasicCheckbox">
            <Form.Label>Assigned Customer Success Manager</Form.Label>
            <Form.Select value={user.csmId} onChange={(arg) => updateCSM(arg.target.value)}>
              {cmsListResult.data?.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </fieldset>
      </RequireTier>

      <div className="form-group">
        <label htmlFor="id" className="form-label">
          Id
        </label>
        <input type="text" className="form-control" id="id" defaultValue={user.id} disabled readOnly />
      </div>

      {user.apiToken && (
        <div className="row align-items-center">
          <div className="col">
            <div className="form-group">
              <label htmlFor="token" className="form-label">
                Token
              </label>
              <input type="text" className="form-control" id="token" defaultValue={user.apiToken} disabled readOnly />
            </div>
          </div>
          <div className="col text-center">
            <button className="btn btn-primary" disabled>
              Generate new token
            </button>
          </div>
        </div>
      )}

      <Form.Group className="mb-3" controlId="trackingCodeCheckbox">
        <RequireTier requiredTier="admin" policy="disable">
          <Form.Check
            type="checkbox"
            label="Tracking code installed"
            checked={user.trackingCodeInstalled}
            onChange={(e) => updateTrackingCodeInstalled(e.target.checked)}
          />
        </RequireTier>
      </Form.Group>

      <UserUpdateButton />
    </>
  );
};

export default UserGeneralTab;
